export default "__VITE_ASSET__BXqJve5U__"